import { Col, Row } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import PlantInfo from 'components/Common/PlantInfo/PlantInfo';
import { selectPlantItemSidebar } from 'components/Common/Sidebar/sidebarSlice';
import Environment from 'features/Plant/components/Environment/Environment';
import { plantActions } from 'features/Plant/plantSlice';
import * as React from 'react';
import Devices from '../../components/Devices/Devices';
import ElectricityCost from '../../components/ElectricityCost/ElectricityCost';
import PlantMenu from '../../components/PlantMenu/PlantMenu';
import style from './PlantManagement.module.scss';
export interface PlantManagementProps {}

export default function PlantManagement(props: PlantManagementProps) {
  const [isShowItem, setIsShowItem] = React.useState<string>('Plant Information');
  const plantItemSelected = useAppSelector(selectPlantItemSidebar);
  const dispatch = useAppDispatch();
  const [isShowPlantDetail, setIsShowPlantDetail] = React.useState(true);

  React.useEffect(() => {
    if (plantItemSelected) {
      (async () => {
        await dispatch(plantActions.fetchPlantInfo({ type: 'plant_id', id: plantItemSelected }));
      })();
    }
  }, [plantItemSelected, dispatch]);
  function renderSwitch(param: string) {
    switch (param) {
      case 'Devices':
        return <Devices />;
      // case 'Performance':
      //   return <Performance />;
      case 'Electricity Cost':
        return <ElectricityCost />;
      case 'Weather Sensor':
        return <Environment itemSelected={plantItemSelected}/>;
      default:
        return (
          <PlantInfo
            isShowPlantDetail={isShowPlantDetail}
            setIsShowPlantDetail={setIsShowPlantDetail}
          />
        );
    }
  }

  return (
    <Row align={'middle'} className={style.root}>
      <Row align={'middle'} className={style.container}>
        <Col span={7} className={style.menu_user}>
          <PlantMenu isShowItem={isShowItem} setIsShowItem={setIsShowItem} />
        </Col>
        <Col span={17} className={style.content}>
          {renderSwitch(isShowItem)}
        </Col>
      </Row>
    </Row>
  );
}
